// src/shared/components/Icon.jsx
import React from "react";
import {
  Search,
  NotificationsNone,
  NotificationsOff,
  FilterAlt,
  Add,
  ExpandMore,
  ChevronRight,
  ChevronLeft,
  ArrowUpward,
  ArrowDownward,
  Close,
  Check,
  Schedule,
  Inbox,
  FormatListBulleted,
  BarChart,
  Group,
  Settings,
  VpnKey,
  DesktopWindows,
  WarningAmber,
  Inventory2,
  Lock,
  Language,
  PersonAdd,
  PersonRemove,
  AttachFile,
  ChatBubbleOutline,
  MoreHoriz,
  Send,
  LocalFireDepartment,
  AutoAwesome,
  Refresh,
  AddCircleOutline,
  CheckCircleOutline,
  Cancel,
  PauseCircleOutline,
  Edit,
  DeleteOutline,
  Sell,
  Person,
  Home,
  Menu,
  Visibility,
  VisibilityOff,
  Download,
  Upload,
  CalendarToday,
  MailOutline,
  Phone,
  Place,
  Link,
  OpenInNew,
  InfoOutlined,
  HelpOutline,
  Shield,
  EmojiEvents,
  Star,
  FavoriteBorder,
  Bolt,
  TrendingUp,
  TrendingDown,
  Timeline,
  TrackChanges,
  Layers,
  GridView,
  Tune,
  Fullscreen,
  FullscreenExit,
  WorkOutline,
  CorporateFare,
} from "@mui/icons-material";

const ICONS = {
  search: Search,
  bell: NotificationsNone,
  "bell-off": NotificationsOff,
  filter: FilterAlt,
  plus: Add,
  "chevron-down": ExpandMore,
  "chevron-right": ChevronRight,
  "chevron-left": ChevronLeft,
  "arrow-up": ArrowUpward,
  "arrow-down": ArrowDownward,
  x: Close,
  check: Check,
  clock: Schedule,
  inbox: Inbox,
  list: FormatListBulleted,
  chart: BarChart,
  users: Group,
  settings: Settings,
  key: VpnKey,
  monitor: DesktopWindows,
  alert: WarningAmber,
  package: Inventory2,
  lock: Lock,
  globe: Language,
  "user-plus": PersonAdd,
  "user-minus": PersonRemove,
  paperclip: AttachFile,
  message: ChatBubbleOutline,
  more: MoreHoriz,
  send: Send,
  flame: LocalFireDepartment,
  sparkle: AutoAwesome,
  refresh: Refresh,
  "plus-circle": AddCircleOutline,
  "check-circle": CheckCircleOutline,
  "x-circle": Cancel,
  "pause-circle": PauseCircleOutline,
  edit: Edit,
  trash: DeleteOutline,
  tag: Sell,
  user: Person,
  home: Home,
  menu: Menu,
  eye: Visibility,
  "eye-off": VisibilityOff,
  download: Download,
  upload: Upload,
  calendar: CalendarToday,
  mail: MailOutline,
  phone: Phone,
  "map-pin": Place,
  link: Link,
  "external-link": OpenInNew,
  info: InfoOutlined,
  help: HelpOutline,
  shield: Shield,
  award: EmojiEvents,
  star: Star,
  heart: FavoriteBorder,
  zap: Bolt,
  "trending-up": TrendingUp,
  "trending-down": TrendingDown,
  activity: Timeline,
  target: TrackChanges,
  layers: Layers,
  grid: GridView,
  sliders: Tune,
  maximize: Fullscreen,
  minimize: FullscreenExit,
  briefcase: WorkOutline,
  building: CorporateFare,
};

export default function Icon({ name, size = 16, stroke = 1.6, ...props }) {
  const Component = ICONS[name] || InfoOutlined;
  return <Component sx={{ fontSize: size }} {...props} />;
}